module.exports = require('../internals/shared')('native-function-to-string', Function.toString);